module.exports = __webpack_public_path__ + "static/media/JinjaNinja_Logo-01.ad617453.png";